import { mapGetters } from 'vuex';
import accountSocialBadge from '@/components/account/account-social-badge/account-social-badge.vue';
import dashboardDesktop from '@/components/dashboard/dashboard-desktop/dashboard-desktop.vue';
import tabs from '@/components/generics/tabs/tabs.vue';
import unreadNotificationMixin from '@/mixins/unreadNotification';
import headerTagsMixin from '@/mixins/headerTags';

const TAB_MARKETS = 'portfolio';
const TAB_INFO = 'info';

export default {
  mixins: [
    headerTagsMixin,
    unreadNotificationMixin,
  ],
  components: {
    accountSocialBadge,
    dashboardDesktop,
    tabs,
  },
  metaInfo() {
    return {
      title: 'Dashboard',
      link: [
        { rel: 'canonical', href: `${window.location.href}` },
      ],
      meta: [
        { itemprop: 'image', content: `${window.location.origin}/static/logo.png` },
        { property: 'og:title', content: 'Dashboard' },
        { property: 'og:type', content: 'article' },
        { property: 'og:image', content: `${window.location.origin}/static/logo.png` },
        { property: 'og:site_name', content: 'Predictit' },
        { property: 'og:url', content: `${window.location.href}` },
      ],
    };
  },
  data() {
    return {
      activeTab: null,
      tabs: [
        { name: TAB_MARKETS, title: 'Markets' },
        { name: TAB_INFO, title: 'Info' },
      ],
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop']),
    isNotificationsRoute() {
      return this.$route.name === 'notifications';
    },
    showSocialBadge() {
      return !this.isNotificationsRoute;
    },
    showTabs() {
      return !this.isNotificationsRoute;
    },
  },
  methods: {
    tabChange(name) {
      this.activeTab = name;
      this.$router.push({ name });
      // if (name === TAB_NOTIFICATIONS) {
      //   this.clearAllNotifications();
      // }
    },
  },
  created() {
    this.reorganizeTags();
  },
  beforeDestroy() {
    if (this.isLayoutDesktop) {
      this.clearAllNotifications();
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/dashboard/page-main/page-main.js